import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import IconEye from '@/ui/icons/IconEye.vue';
import IconEyeDisabled from '@/ui/icons/IconEyeDisabled.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordField',
  props: {
    value: null,
    error: null,
    description: null,
    customAriaErrorMessageId: null,
    customAriaInvalid: { type: Boolean }
  },
  setup(__props: any) {



const showPassword = ref<boolean>(false);

return { __sfc: true,showPassword, IconEye, IconEyeDisabled }
}

})